import i18n from 'src/i18n/i18n'

class Roles {
  constructor (roles) {
    this.roles = roles

    this.forSelect = this.roles.map(role => {
      return { label: this.name(role), value: role }
    })
  }

  name (id) {
    return i18n.t(`role_${id}`)
  }
}

export default new Roles([0, 1, 2, 3])
